import React from 'react';
import { Fragment } from 'react';
import { TackShape, UserShape } from '../shapes';
import { Link } from 'react-router-dom';
import DateMaster from '../stores/utils/date_master';
import TackLikeButton from './tack_like_button';
import UserTackProgress from './user_tack_progress';
import PropTypes from 'prop-types';

export default class UserTack extends React.Component {

  static propTypes = {
    user: UserShape,
    tack: TackShape,
    onLikeTack: PropTypes.func,
    onUnLikeTack: PropTypes.func
  }

  render() {
    let nextMeta;
    if (this.props.tack.get('done')) {
      nextMeta = this.renderFinishedAt();
    } else {
      nextMeta = this.renderNextEmail();
    }

    return(
      <div className='user-tack'>
        <Link to={ `/words/${ this.props.tack.get('wordText') }/${ this.props.tack.get('language') }` }>
          <h4 className='word-title'>{ this.props.tack.get('wordText') }</h4>
        </Link>
        <ul className='item-meta'>
          { nextMeta }
        </ul>
      </div>
    );
  }

  renderNextEmail() {
    const nextDate = this.nextTackDate(this.props.tack.get('nextSendDate'));
    return (
      <Fragment>
        <li>
          <UserTackProgress currentInterval={ this.props.tack.get('currentInterval') }></UserTackProgress>
        </li>        
        <li>
          <b>Started</b>: { DateMaster.format(this.props.tack.get('createdAt')) }
        </li>
        <li>
          <b>Next Tack</b>: { nextDate }
        </li>
        <li>
          <TackLikeButton tackId={ this.props.tack.get('slug') } user={ this.props.user } likedBy={ this.props.tack.get('likedBy') } onLikeTack={ this.props.onLikeTack } onUnLikeTack={ this.props.onUnLikeTack } />
        </li>
      </Fragment>
    );
  }

  renderFinishedAt() {
    const finishedDate = DateMaster.format(this.props.tack.get('lastSentDate'));
    return (
      <Fragment>
        <li>
          <b>Finished</b>: { finishedDate }
        </li>
        <li>
          <TackLikeButton tackId={ this.props.tack.get('slug') } user={ this.props.user } likedBy={ this.props.tack.get('likedBy') } onLikeTack={ this.props.onLikeTack } onUnLikeTack={ this.props.onUnLikeTack } />
        </li>
      </Fragment>
    );
  }

  nextTackDate(nextSendDateString) {
    if ((new Date(nextSendDateString)) < (new Date())) {
      return 'Tomorrow';
    } else {
      return DateMaster.format(DateMaster.addDays(nextSendDateString, 1));
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/user_tack.jsx